import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.top-brands';

const getBrandHref = (brand) => {
  const id = brand.brand_id ?? '';
  const name = encodeURIComponent(brand.name ?? '');
  return `/searchbrand?querybrand=${id}&name=${name}`;
};

const getBrandsFromResponse = (response, id) => {
  const merchandising = response?.data?.brandmerchandising;
  if (!merchandising) return [];

  return merchandising[id]
    ?? merchandising[String(id)]
    ?? merchandising[Number(id)]
    ?? [];
};

const renderBrandSlides = (listEl, brands) => {
  listEl.innerHTML = '';

  brands.forEach((brand) => {
    if (!brand?.image_path) return;

    const href = getBrandHref(brand);
    const name = brand.name ?? '';

    listEl.insertAdjacentHTML('beforeend', /* html */ `
      <div class="splide__slide">
        <a class="top-brands__card" href="${href}" title="${name}">
          <img class="top-brands__logo" src="${brand.image_path}" alt="${name}" loading="lazy">
        </a>
      </div>
    `);
  });
};

const getSplideOptions = (slideCount) => ({
  type: 'loop',
  rewind: true,
  perPage: 5,
  perMove: 1,
  gap: 15,
  padding: '45px',
  arrows: false,
  pagination: slideCount > 5,
  drag: slideCount > 5,
  breakpoints: {
    1500: {
      perPage: 4,
      pagination: slideCount > 4,
      drag: slideCount > 4,
    },
    1200: {
      perPage: 3,
      pagination: slideCount > 3,
      drag: slideCount > 3,
    },
    991: {
      perPage: 4,
      pagination: false,
      arrows: slideCount > 4,
      drag: slideCount > 4,
    },
    768: {
      perPage: 2,
      pagination: false,
      arrows: slideCount > 2,
      drag: slideCount > 2,
    },
    576: {
      perPage: 1,
      pagination: false,
      arrows: slideCount > 1,
      drag: slideCount > 1,
    },
  },
});

const createSliderEl = (category) => {
  const wrapper = document.createElement('div');
  wrapper.className = 'top-brands__slider';
  wrapper.innerHTML = /* html */ `
    <p class="top-brands__slider-title">${category}</p>
    <section class="splide">
      <div class="splide__track">
        <div class="splide__list"></div>
      </div>
    </section>
  `;
  return wrapper;
};

const loadBrands = (sliderEl, id) => {
  const splideEl = sliderEl.querySelector('.splide');
  const listEl = sliderEl.querySelector('.splide__list');

  if (!splideEl || !listEl || !id) return;

  if (typeof $ === 'undefined') {
    console.error(`${moduleSelector}: jQuery is required for brand merchandising AJAX`);
    return;
  }

  sliderEl.classList.add('top-brands__slider--loading');

  $.ajax({
    type: 'post',
    url: '/ajax/merchandising',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
    data: {
      groupBrandMerchandising_ids: [id],
    },
    timeout: 30000,
    success: (response) => {
      sliderEl.classList.remove('top-brands__slider--loading');

      const brands = getBrandsFromResponse(response, id);
      renderBrandSlides(listEl, brands);

      const slideCount = listEl.querySelectorAll('.splide__slide').length;
      if (!slideCount) return;

      setTimeout(() => {
        const instance = new Splide(splideEl, getSplideOptions(slideCount));
        instance.mount();
      }, 100);
    },
    error: (xhr, status, error) => {
      sliderEl.classList.remove('top-brands__slider--loading');
      console.error(`${moduleSelector}: Error loading brands: ${status} - ${error}`, xhr);
      listEl.innerHTML = '';
    },
  });
};

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((root) => {
    try {
      root.querySelector('script')?.remove();

      const { data } = dJSON.parse(root.data);
      if (!Array.isArray(data) || !data.length) return;

      const slidersContainer = root.querySelector('.top-brands__sliders');
      if (!slidersContainer) return;

      data.forEach((item) => {
        const sliderEl = createSliderEl(item.category ?? '');
        slidersContainer.appendChild(sliderEl);
        loadBrands(sliderEl, item.id);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
